import { render } from "./CompanyHistoryView.vue?vue&type=template&id=3b32eaa7&scoped=true"
import script from "./CompanyHistoryView.vue?vue&type=script&lang=js"
export * from "./CompanyHistoryView.vue?vue&type=script&lang=js"

import "./CompanyHistoryView.vue?vue&type=style&index=0&id=3b32eaa7&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b32eaa7"]])

export default __exports__